import { gsap, Power1 } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded',function() {
    gsap.registerPlugin(ScrollTrigger);
    
    window.anims = function() {
        
        gsap.utils.toArray(".js-fadeInChildren > *").forEach(function(section) {
            gsap.from(section, {
                scrollTrigger: {
                    trigger: section,
                    start: '-50px bottom',
                    toggleActions: "play complete complete reset",
                },
                opacity: 0, 
                duration: 1,
                y: 50
            });
        });
        
        const signature = function() {
            ScrollTrigger.batch(".js-signature p", {
                onEnter: elements => {
                    gsap.from(elements, {
                        autoAlpha: 0,
                        x: -60,
                        stagger: 0.55,
                        
                    });
                },
                
                once: false
            });
        }();
        
        
        const hero = function() {            
            const dots = function() {
                  
            }();
        }();
        
        const program = function() {
/*
            ScrollTrigger.batch(".c-program .o-cols__item", {
                onEnter: elements => {
                    gsap.from(elements, {
                        autoAlpha: 0,
                        y: 60,
                        stagger: 0.15,
                    });
                },
            });
*/
            
/*
            const sections = gsap.utils.toArray(".c-program .o-cols--icons");

            sections.forEach( section => {
                gsap.from(section.querySelectorAll(".o-cols--icons .o-cols__item"), {
                    opacity: 0,
                    y: 50,
                    duration: .5,
                    stagger: 0.15,
                    scrollTrigger: {
                        trigger: section,
                        start: "top bottom-=50",
                    }
                });
            });
*/
            
            const dashes = function() {
                gsap.from('.c-program .js-dashes', {
                    scrollTrigger: { trigger: '.c-program', scrub: 1 }, y: -100
                });  
            }();
            
            const dots = function() {
                gsap.to('.c-program .js-dots-1', {
                    scrollTrigger: { trigger: '.c-program', scrub: 1 }, y: 50
                });
                
                gsap.from('.c-program .js-dots-2', {
                    scrollTrigger: { trigger: '.c-program', scrub: 1 }, y: -200
                });  
            }();
        }();
        
        const cards = function() {
            gsap.from('.js-cards', {
                scrollTrigger: {
                    trigger: '.js-cards',
                    scrub: 2.2,
                    start: 'top bottom',
                    end: 'top center'
                },      
                xPercent: 15
            });
        }();
        
        const work = function() {
            gsap.from('.js-workSwiper', {
                scrollTrigger: {
                    trigger: '.js-workSwiper',
                    scrub: 2.2,
                    start: 'top bottom',
                    end: 'top center'
                },      
                xPercent: -15
            });
            
            gsap.from('.c-work .js-dots', {
                scrollTrigger: { trigger: '.c-work', scrub: 1 }, y: -200
            });
        }();
        
        const process = function() {
            const dashes = function() {
                gsap.from('.c-process .js-dashes', {
                    scrollTrigger: { trigger: '.c-process', scrub: 1 }, x: -100
                });  
            }();
            
            const circle = function() {
                gsap.from('.c-process .js-circle', {
                    scrollTrigger: {
                        trigger: '.c-process .js-circle',
                        scrub: 2.2,
                        start: 'top bottom',
                        end: 'top center'
                    },      
                    xPercent: 50,
                    scale: .5
                }); 
            }();
            
            const dots = function() {
                gsap.from('.c-process .js-dots', {
                    scrollTrigger: { trigger: '.c-process', scrub: 1 }, y: -600
                });  
            }();
        }();
        
        const faq = function() {
            const dashes = function() {
                gsap.from('.c-faq .js-lines', {
                    scrollTrigger: { trigger: '.c-faq', scrub: 1 }, y: -100
                });  
            }();
            
            const dots = function() {
                gsap.from('.c-faq .js-dots', {
                    scrollTrigger: { trigger: '.c-faq', scrub: 1 }, y: 300
                });  
            }();
        }();
    };

}, false)
